import React from "react";
import { useParams } from "react-router-dom";
import UserCustomDashboard from "../index";
import { StoreWorkspaceProvider } from "../../storeSupport/StoreWorkspaceContext";

const StoreEmLayoutShell = () => {
  const { id } = useParams();

  return (
    <StoreWorkspaceProvider key={id}>
      <UserCustomDashboard />
    </StoreWorkspaceProvider>
  );
};

export default StoreEmLayoutShell;
